module.exports = __webpack_public_path__ + "img/404@2x.59e9a285.png";